<style lang="scss" scoped>


.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

.row_action {
  cursor: pointer;
  &:hover {
    background-color: #F8FAFC;
  }
}

.row_action:first-child {
  cursor: pointer;
  &:hover {
    background-color: #EFF5FB;
  }
}

.bold-text {
    font-weight: 800;
}

</style>

<template>
    
    <div class="row align-items-center p-2">
        <div class="col">
            <!-- Page pre-title -->
            <div class="page-pretitle">
                Sensormessung
            </div>
            <h2 class="page-title">
                Lokale Niederschläge
            </h2>
        </div>
        <!-- Page title actions -->
        <div class="col-auto ms-auto d-print-none">
            <div class="btn-list">
                <a href="#" class="btn btn-info d-none d-sm-inline-block" @click="openAlterModal">
                <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                Manuell dokumentieren
                </a>
                <a href="#" class="btn btn-info d-sm-none btn-icon" @click="openAlterModal"
                aria-label="Create new report">
                <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </a>
            </div>
        </div>
    </div>
    
    <Alert type="info" :show="alertEmpty">
        <template v-slot:title>Keine lokalen Niederschläge dokumentiert</template>
        Zur Dokumentation von lokalen Niederschlägen klicken Sie bitte auf das blau hinterlegte PLUS
    </Alert>
    
    <Alert type="success" :show="alertNew"  :timeout="3000">
        <template v-slot:title>Lokale Niederschläge dokumentiert</template>
        Die lokale Niederschläge wurden dokumentiert
    </Alert> 
    
    <Alert type="success" :show="alertRemove" :timeout="3000">
        <template v-slot:title>Lokaler Niederschlag gelöscht</template>
        Der lokale Niederschlag wurde aus der Liste gelöscht
    </Alert>   
    
        
    <div v-show="loading || loadingSensorSelect" class="progress progress-sm mb-2">
        <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
    </div>
    <div class="row mt-1 mb-2">
        <div class="col-12">
            <SensorSelect :profile="profile" :parameterId="'n'" @addSensorToProfile="onSensorChanged" 
            @removeSensorFromProfile="onSensorChanged" v-model:loading="loadingSensorSelect"></SensorSelect>
        </div>
    </div>
    <div v-show="precipitationList.length > 0" class="card_">
        <div class="table-responsive mt-2">
            <table class="table table-vcenter card-table">
                <thead>
                    <tr>
                        <th>
                            Datum
                        </th>
                        <th>
                            Lokaler Niederschlag 
                        </th>
                        
                        <th>
                            Quelle
                        </th>
                        <th>
                            Wetterstation-Niederschlag 
                        </th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="record in reverseList(precipitationList)" v-bind:key="record.date" @click="record.type == 'manually' ? openRemoveModal(record): null" 
                        :class="[record.type == 'manually' ? 'row_action': '']" :title="record.type == 'manually' ? 'Messung entfernen': ''" >
                        <td>
                            <small class="d-block text-truncate text-muted">
                                {{ formatDate(record.date, 'DD.MM.YYYY') }}
                            </small>
                        </td>
                        <td>
                            <small class="d-block text-truncate bold-text">
                                {{ utils.roundToFixedDe(record.value, 0) }} mm
                            </small>
                            <div class="progress progress-sm">
                                <div class="progress-bar bg-primary" :style="{width: '{}%'.format(record.value * 33)}">
                                </div>
                            </div>
                        </td>
                        <td>
                            <span v-if="record.type == 'sensor'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                </svg>                        
                                <small class="text-muted text-truncate ms-0">
                                    Sensor
                                </small>
                            </span>
                            <span v-else-if="record.type == 'manually'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" transform="matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,0)">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z" />
                                    <path d="M9 12v2" />
                                    <path d="M6 12v3" />
                                    <path d="M12 12v3" />
                                    <path d="M18 12v3" />
                                    <path d="M15 12v2" />
                                    <path d="M3 3v4" />
                                    <path d="M3 5h18" />
                                    <path d="M21 3v4" />
                                </svg>                        
                                <small class="text-muted text-truncate ms-0">
                                    Manuell
                                </small>
                            </span>
                            <span v-else-if="record.type == 'historical'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M12 3l2 3l2 15h-8l2 -15z" />
                                    <path d="M8 9l8 0" />
                                    <path d="M3 11l2 -2l-2 -2" />
                                    <path d="M21 11l-2 -2l2 -2" />
                                </svg>                        
                                <small class="text-muted text-truncate ms-0">
                                    Station
                                </small>
                            </span>
                            <span v-else-if="record.type == 'forecast'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M6 21l6 -5l6 5" />
                                    <path d="M12 13v8" />
                                    <path d="M3.294 13.678l.166 .281c.52 .88 1.624 1.265 2.605 .91l14.242 -5.165a1.023 1.023 0 0 0 .565 -1.456l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-12.694 7.618c-1.02 .613 -1.357 1.897 -.76 2.905z" />
                                    <path d="M14 5l3 5.5" />
                                </svg>                        
                                <small class="text-muted text-truncate ms-0">
                                    Prognose
                                </small>
                            </span>
                            <span v-else>
                                {{ record.type }}
                            </span>
                        </td>
                        <td>
                            <small class="d-block text-muted text-truncate">
                                {{ utils.roundToFixedDe(record.valueOriginal, 0) }} mm
                            </small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <AlterModal  ref="alterPrecipitation" :correctionList="correctionList" v-on:submit="addCorrection"></AlterModal>
    <RemoveModal ref="removePrecipitation" :correction="correction" v-on:removeCorrection="removeCorrection"></RemoveModal>
</template>

<script>

import * as dayjs from 'dayjs';
import axios from 'axios';

import SensorSelect from '@/components/sensor/SensorSelect.vue';
import AlterModal from '@/components/precipitation/AlterModal.vue';
import RemoveModal from '@/components/precipitation/RemoveModal.vue';
import Alert from '@/components/Alert.vue';

export default {
    name: 'Precipitation',
    components: {
        SensorSelect,
        AlterModal,
        RemoveModal,
        Alert
    },
    inject: [
        'state',
        'config',
        'utils'
    ],
    props: {
        profile: {
            type: Object,
            default: undefined
        }
    },
    data: function () {
        return {
            parameterId: 'n',
            correctionList: [],
            loading: false,
            loadingSensorSelect: false,
            alertNew: false,
            alertEmpty: false,
            alertRemove: false,
            correction: {},
            weatherData: [],
            weatherDataCorrected: []
        }
    },
    computed: {
        precipitationList: function() {
            const self = this;
        
            const weatherData = self.weatherData.reduce( function(result, record) {
                result[record.datum] = record;
                return result;
            }, {});
            
            const precipitationList = self.weatherDataCorrected.map( function (record) {
                const value = record[self.parameterId];
                const valueOriginal = weatherData[record.datum] ? weatherData[record.datum][self.parameterId]: null;
                
                const source = record['source_' + self.parameterId];
                const source_common = record['source'];
                const type = source && source.type ? source.type: source_common.type;  
                
                return {
                    date: record.datum,
                    value: value,
                    valueOriginal: valueOriginal,
                    type: type
                }
                
            });
            
            return precipitationList.filter( function (record) {
                return ['manually', 'sensor'].includes(record.type);
            });
        }
    },
    methods: {
        openAlterModal: function () {   
            this.$refs.alterPrecipitation.openModal();
        },
        addCorrection: function (correction) {
            let self = this;
            
            self.alertNew = false;
            self.addData(correction, function () {
                self.alertNew = true;
            });
        },
        openRemoveModal: function (correction) {   
            this.correction = correction;
            this.$refs.removePrecipitation.openModal();
        },
        removeCorrection: function (correction) {
            const self = this;
            
            self.alertRemove = false;
            self.removeData(correction, function () {
                self.alertRemove = true;
            });
        },
        reverseList: function (list) {
            return [].concat(list).reverse();
        },
        formatDate: function (dateString, format) {
            return dayjs(dateString).format(format);
        },
        parseJSONList: function (list) {
            return list.map( function (record) {
                return JSON.parse(record);
            });
        },
        onSensorChanged: function(sensor) {
            this.loading = true;
            this.fetchData();
        },
        sensorSelectLoading: function(value) {
            if (this.loading !== value) {
                this.loading = value;
            }
        },
        updateWeatherData: function (weatherData) {
            if (weatherData.weatherData) {
                this.weatherData = this.parseJSONList(weatherData.weatherData);
            }
            
            if (weatherData.chainedWeatherData) {
                this.weatherDataCorrected = this.parseJSONList(weatherData.chainedWeatherData);
                
            }
        },
        fetchData: function (callback) {
            const self = this;
           
            const query = {
                query: `
                    query (
                        $profileId: Int!
                        $year: Int
                        $attributeIds: [String]
                    ) {
                        user {
                            profile (
                                profileId: $profileId
                                year: $year
                            ) {
                                id
                                weatherstation {
                                    id
                                    label
                                    provider
                                    altitude
                                    weatherData (attributeIds: $attributeIds)
                                    chainedWeatherData (attributeIds: $attributeIds)
                                }
                            }
                            loggedIn
                        }
                    }
                `,      
                variables: {
                    profileId : self.profile.id,
                    year: self.profile.year,
                    attributeIds: ['datum', self.parameterId]
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data) {
                    self.updateWeatherData(data.user.profile.weatherstation);
                })
             
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
            
        },
        addData: function (correction, callback) {
            let self = this;
                       
            let query = {
                query: `
                    mutation (
                        $profileId: Int!
                        $precipitation: Int! 
                        $startDate: String! 
                        $endDate: String!
                        $year: Int! 
                        $attributeIds: [String]
                    ) {
                        newPrecipitation (
                            profileId: $profileId,
                            precipitation: $precipitation,
                            startDate: $startDate
                            endDate: $endDate
                            year: $year
                        ) {
                            user {
                                profile (profileId: $profileId) {
                                    id
                                    weatherstation {
                                        id
                                        label
                                        provider
                                        altitude
                                        weatherData (attributeIds: $attributeIds)
                                        chainedWeatherData (attributeIds: $attributeIds)
                                    }
                                }
                                loggedIn
                            }
                        }
                    }
                `,      
                variables: {
                    profileId : self.state.profile.id,
                    precipitation: correction.precipitation,
                    startDate: correction.startDate,
                    endDate: correction.endDate,
                    year: this.state.profile.year,
                    attributeIds: ['datum', self.parameterId]
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.updateWeatherData(data.newPrecipitation.user.profile.weatherstation);
                })
             
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
            
        },
        removeData: function (correction, callback) {
            let self = this;
                       
            let query = {
                query: `
                    mutation (
                        $profileId: Int!, 
                        $date: String!
                        $attributeIds: [String]
                    ) {
                        removePrecipitation (
                                profileId: $profileId,
                                date: $date
                        ) {
                            user {
                                profile (profileId: $profileId) {
                                    id
                                    weatherstation {
                                        id
                                        label
                                        provider
                                        altitude
                                        weatherData (attributeIds: $attributeIds)
                                        chainedWeatherData (attributeIds: $attributeIds)
                                    }
                                }
                                loggedIn
                            }
                        }
                    }
                `,      
                variables: {
                    profileId : self.state.profile.id,
                    date: correction.date,
                    attributeIds: ['datum', self.parameterId]
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.updateWeatherData(data.removePrecipitation.user.profile.weatherstation);
                })
             
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        }
    },
    created: function () {
        
    },
    mounted: function () {
        this.fetchData();
    },
    watch: {
        loading: function (new_value, old_value) {
            // LOADING STARTING
            if ( new_value === true && old_value === false ) {
                this.alertEmpty = false;
            }
    
            // LOADING FINISHED
            if ( new_value === false && old_value === true ) {
                if (this.precipitationList.length == 0) {
                    this.alertEmpty = true;
                } else {
                    this.alertEmpty = false;
                }      
            }
        }        
    }
}
</script>